'use strict';

module.exports = function (ngModule) {
    // routes
    require('./routes')(ngModule);
    // controllers
    require('./controllers')(ngModule);
    // directives
    require('./directives')(ngModule);
}


/** WEBPACK FOOTER **
 ** ./src/changelog/index.js
 **/